/**
 * AP-39 Nachtrag 2 (6.2) — **„Angebote übernehmen" in der Kalkulation.**
 *
 * Der Preisspiegel **dieser** Kalkulation als Fenster: je Materialzeile die Antworten der Lieferanten, netto je
 * Einheit der Zeile, der günstigste vorgewählt, „Preise übernehmen" mit Vorschau (Detailblatt O 7.3, 7.4). Geöffnet
 * vom Kopf der Kalkulation („n Angebote nicht übernommen"), vom Hinweis der Übersicht und von der Marke an der
 * Materialzeile („vergleichen") — kein Seitenwechsel ins Cockpit (PE-118). Das Cockpit bleibt für den Einkauf über
 * alle Kalkulationen.
 */
import { Link } from 'react-router-dom'
import { X } from 'lucide-react'
import { erfuelltRecht } from '@symphenia/shared-types'
import { useAuthStore } from '@/lib/auth.store'
import { PreisspiegelReiter } from './PreisspiegelReiter'

export function AngeboteUebernehmen({
  kalkulation,
  onClose,
  onGeaendert,
}: {
  kalkulation: { id: string; label: string; name: string }
  onClose: () => void
  /** nach dem Übernehmen — die Kalkulation hat neu gerechnet */
  onGeaendert: () => void
}) {
  const { user } = useAuthStore()
  const cockpit = erfuelltRecht('calculation.request.manage', user?.permissions)
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/40 p-4" role="dialog" aria-modal="true" aria-label="Angebote übernehmen">
      <div className="w-full max-w-6xl rounded-lg border border-border p-5 shadow-xl" style={{ background: 'hsl(var(--card))', color: 'hsl(var(--card-foreground))' }}>
        <div className="mb-3 flex items-start justify-between gap-3">
          <div>
            <h2 className="text-lg font-semibold">Angebote übernehmen</h2>
            <p className="text-xs text-muted-foreground">
              Kalkulation {kalkulation.label} {kalkulation.name} — je Materialzeile die Angebote der Lieferanten, netto je Einheit der Zeile. Der
              günstigste ist vorgewählt; eine andere Zelle anklicken wählt um. „Preise übernehmen" zeigt zuerst die Wirkung.
            </p>
          </div>
          <div className="flex shrink-0 items-center gap-3">
            {cockpit && (
              <Link to={`/calculations/material-requests?tab=preisspiegel&calculationId=${kalkulation.id}`} className="text-xs text-primary hover:underline">
                im Cockpit Materialanfragen
              </Link>
            )}
            <button type="button" onClick={onClose} className="text-muted-foreground hover:text-foreground" aria-label="Schließen">
              <X className="h-5 w-5" />
            </button>
          </div>
        </div>
        <PreisspiegelReiter
          calculationId={kalkulation.id}
          nurDiese
          onGeaendert={() => {
            onGeaendert()
            onClose()
          }}
        />
      </div>
    </div>
  )
}
